// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-1ea9d450] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.modal-mask[data-v-1ea9d450] {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: #00000080;
}
.modal-mask--dark[data-v-1ea9d450] {
  background-color: #000000eb;
}
.modal-header[data-v-1ea9d450] {
  position: absolute;
  z-index: 10001;
  top: 0;
  right: 0;
  left: 0;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  overflow: hidden;
  transition: opacity .25s, visibility .25s;
}
.modal-header .modal-name[data-v-1ea9d450] {
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 0 132px 0 12px;
  transition: padding ease .1s;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #fff;
  font-size: 14px;
  margin-bottom: 0;
}
@media only screen and (min-width: 1024px) {
  .modal-header .modal-name[data-v-1ea9d450] {
    padding-left: 132px;
    text-align: center;
  }
}
.modal-header .icons-menu[data-v-1ea9d450] {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.modal-header .icons-menu .header-close[data-v-1ea9d450] {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 3px;
  padding: 0;
}
.modal-header .icons-menu .play-pause-icons[data-v-1ea9d450] {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: none;
  background-color: transparent;
}
.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__play[data-v-1ea9d450],
.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__pause[data-v-1ea9d450],
.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__play[data-v-1ea9d450],
.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__pause[data-v-1ea9d450] {
  opacity: 1;
  border-radius: 22px;
  background-color: #7f7f7f40;
}
.modal-header .icons-menu .play-pause-icons__play[data-v-1ea9d450],
.modal-header .icons-menu .play-pause-icons__pause[data-v-1ea9d450] {
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  margin: 3px;
  cursor: pointer;
  opacity: .7;
}
.modal-header .icons-menu .header-actions[data-v-1ea9d450] {
  color: #fff;
}
.modal-header .icons-menu[data-v-1ea9d450] .action-item {
  margin: 3px;
}
.modal-header .icons-menu[data-v-1ea9d450] .action-item--single {
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  cursor: pointer;
  background-position: center;
  background-size: 22px;
}
.modal-header .icons-menu[data-v-1ea9d450] button {
  color: #fff;
}
.modal-header .icons-menu[data-v-1ea9d450] .action-item__menutoggle {
  padding: 0;
}
.modal-header .icons-menu[data-v-1ea9d450] .action-item__menutoggle span,
.modal-header .icons-menu[data-v-1ea9d450] .action-item__menutoggle svg {
  width: var(--icon-size);
  height: var(--icon-size);
}
.modal-wrapper[data-v-1ea9d450] {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.modal-wrapper .prev[data-v-1ea9d450],
.modal-wrapper .next[data-v-1ea9d450] {
  z-index: 10000;
  height: 35vh;
  min-height: 300px;
  position: absolute;
  transition: opacity .25s;
  color: #fff;
}
.modal-wrapper .prev[data-v-1ea9d450]:focus-visible,
.modal-wrapper .next[data-v-1ea9d450]:focus-visible {
  box-shadow: 0 0 0 2px var(--color-primary-element-text);
  background-color: var(--color-box-shadow);
}
.modal-wrapper .prev[data-v-1ea9d450] {
  left: 2px;
}
.modal-wrapper .next[data-v-1ea9d450] {
  right: 2px;
}
.modal-wrapper .modal-container[data-v-1ea9d450] {
  position: relative;
  display: flex;
  padding: 0;
  transition: transform .3s ease;
  border-radius: var(--border-radius-large);
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  box-shadow: 0 0 40px #0003;
}
.modal-wrapper .modal-container__close[data-v-1ea9d450] {
  z-index: 1;
  position: absolute;
  top: 4px;
  right: 4px;
}
.modal-wrapper .modal-container__content[data-v-1ea9d450] {
  width: 100%;
  min-height: 52px;
  overflow: auto;
}
.modal-wrapper--small > .modal-container[data-v-1ea9d450] {
  width: 400px;
  max-width: 90%;
  max-height: min(90%, 100% - 100px);
}
.modal-wrapper--normal > .modal-container[data-v-1ea9d450] {
  max-width: 90%;
  width: 600px;
  max-height: min(90%, 100% - 100px);
}
.modal-wrapper--large > .modal-container[data-v-1ea9d450] {
  max-width: 90%;
  width: 900px;
  max-height: min(90%, 100% - 100px);
}
.modal-wrapper--full > .modal-container[data-v-1ea9d450] {
  width: 100%;
  height: calc(100% - var(--header-height));
  position: absolute;
  top: 50px;
  border-radius: 0;
}
@media only screen and ((max-width: 512px) or (max-height: 400px)) {
  .modal-wrapper .modal-container[data-v-1ea9d450] {
    max-width: initial;
    width: 100%;
    max-height: initial;
    height: calc(100% - var(--header-height));
    position: absolute;
    top: 50px;
    border-radius: 0;
  }
}
.fade-enter-active[data-v-1ea9d450],
.fade-leave-active[data-v-1ea9d450] {
  transition: opacity .25s;
}
.fade-enter[data-v-1ea9d450],
.fade-leave-to[data-v-1ea9d450] {
  opacity: 0;
}
.fade-visibility-enter[data-v-1ea9d450],
.fade-visibility-leave-to[data-v-1ea9d450] {
  visibility: hidden;
  opacity: 0;
}
.modal-in-enter-active[data-v-1ea9d450],
.modal-in-leave-active[data-v-1ea9d450],
.modal-out-enter-active[data-v-1ea9d450],
.modal-out-leave-active[data-v-1ea9d450] {
  transition: opacity .25s;
}
.modal-in-enter[data-v-1ea9d450],
.modal-in-leave-to[data-v-1ea9d450],
.modal-out-enter[data-v-1ea9d450],
.modal-out-leave-to[data-v-1ea9d450] {
  opacity: 0;
}
.modal-in-enter .modal-container[data-v-1ea9d450],
.modal-in-leave-to .modal-container[data-v-1ea9d450] {
  transform: scale(.9);
}
.modal-out-enter .modal-container[data-v-1ea9d450],
.modal-out-leave-to .modal-container[data-v-1ea9d450] {
  transform: scale(1.1);
}
.modal-mask .play-pause-icons .progress-ring[data-v-1ea9d450] {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg);
}
.modal-mask .play-pause-icons .progress-ring .progress-ring__circle[data-v-1ea9d450] {
  transition: .1s stroke-dashoffset;
  transform-origin: 50% 50%;
  animation: progressring-1ea9d450 linear var(--slideshow-duration) infinite;
  stroke-linecap: round;
  stroke-dashoffset: 94.2477796077;
  stroke-dasharray: 94.2477796077;
}
.modal-mask .play-pause-icons--paused .icon-pause[data-v-1ea9d450] {
  animation: breath-1ea9d450 2s cubic-bezier(.4, 0, .2, 1) infinite;
}
.modal-mask .play-pause-icons--paused .progress-ring__circle[data-v-1ea9d450] {
  animation-play-state: paused !important;
}
@keyframes progressring-1ea9d450 {
  0% {
    stroke-dashoffset: 94.2477796077;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes breath-1ea9d450 {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcModal-CwgrmxSg.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,OAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;AACA;;;;EAIE,UAAU;EACV,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;;EAEE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;AACA;;EAEE,uDAAuD;EACvD,yCAAyC;AAC3C;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,yCAAyC;EACzC,8CAA8C;EAC9C,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;AACF;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,0EAA0E;EAC1E,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,iEAAiE;AACnE;AACA;EACE,uCAAuC;AACzC;AACA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-1ea9d450] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.modal-mask[data-v-1ea9d450] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: #00000080;\n}\n.modal-mask--dark[data-v-1ea9d450] {\n  background-color: #000000eb;\n}\n.modal-header[data-v-1ea9d450] {\n  position: absolute;\n  z-index: 10001;\n  top: 0;\n  right: 0;\n  left: 0;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  overflow: hidden;\n  transition: opacity .25s, visibility .25s;\n}\n.modal-header .modal-name[data-v-1ea9d450] {\n  overflow-x: hidden;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 132px 0 12px;\n  transition: padding ease .1s;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n@media only screen and (min-width: 1024px) {\n  .modal-header .modal-name[data-v-1ea9d450] {\n    padding-left: 132px;\n    text-align: center;\n  }\n}\n.modal-header .icons-menu[data-v-1ea9d450] {\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.modal-header .icons-menu .header-close[data-v-1ea9d450] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  margin: 3px;\n  padding: 0;\n}\n.modal-header .icons-menu .play-pause-icons[data-v-1ea9d450] {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__play[data-v-1ea9d450],\n.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__pause[data-v-1ea9d450],\n.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__play[data-v-1ea9d450],\n.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__pause[data-v-1ea9d450] {\n  opacity: 1;\n  border-radius: 22px;\n  background-color: #7f7f7f40;\n}\n.modal-header .icons-menu .play-pause-icons__play[data-v-1ea9d450],\n.modal-header .icons-menu .play-pause-icons__pause[data-v-1ea9d450] {\n  box-sizing: border-box;\n  width: 44px;\n  height: 44px;\n  margin: 3px;\n  cursor: pointer;\n  opacity: .7;\n}\n.modal-header .icons-menu .header-actions[data-v-1ea9d450] {\n  color: #fff;\n}\n.modal-header .icons-menu[data-v-1ea9d450] .action-item {\n  margin: 3px;\n}\n.modal-header .icons-menu[data-v-1ea9d450] .action-item--single {\n  box-sizing: border-box;\n  width: 44px;\n  height: 44px;\n  cursor: pointer;\n  background-position: center;\n  background-size: 22px;\n}\n.modal-header .icons-menu[data-v-1ea9d450] button {\n  color: #fff;\n}\n.modal-header .icons-menu[data-v-1ea9d450] .action-item__menutoggle {\n  padding: 0;\n}\n.modal-header .icons-menu[data-v-1ea9d450] .action-item__menutoggle span,\n.modal-header .icons-menu[data-v-1ea9d450] .action-item__menutoggle svg {\n  width: var(--icon-size);\n  height: var(--icon-size);\n}\n.modal-wrapper[data-v-1ea9d450] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n}\n.modal-wrapper .prev[data-v-1ea9d450],\n.modal-wrapper .next[data-v-1ea9d450] {\n  z-index: 10000;\n  height: 35vh;\n  min-height: 300px;\n  position: absolute;\n  transition: opacity .25s;\n  color: #fff;\n}\n.modal-wrapper .prev[data-v-1ea9d450]:focus-visible,\n.modal-wrapper .next[data-v-1ea9d450]:focus-visible {\n  box-shadow: 0 0 0 2px var(--color-primary-element-text);\n  background-color: var(--color-box-shadow);\n}\n.modal-wrapper .prev[data-v-1ea9d450] {\n  left: 2px;\n}\n.modal-wrapper .next[data-v-1ea9d450] {\n  right: 2px;\n}\n.modal-wrapper .modal-container[data-v-1ea9d450] {\n  position: relative;\n  display: flex;\n  padding: 0;\n  transition: transform .3s ease;\n  border-radius: var(--border-radius-large);\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  box-shadow: 0 0 40px #0003;\n}\n.modal-wrapper .modal-container__close[data-v-1ea9d450] {\n  z-index: 1;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n.modal-wrapper .modal-container__content[data-v-1ea9d450] {\n  width: 100%;\n  min-height: 52px;\n  overflow: auto;\n}\n.modal-wrapper--small > .modal-container[data-v-1ea9d450] {\n  width: 400px;\n  max-width: 90%;\n  max-height: min(90%, 100% - 100px);\n}\n.modal-wrapper--normal > .modal-container[data-v-1ea9d450] {\n  max-width: 90%;\n  width: 600px;\n  max-height: min(90%, 100% - 100px);\n}\n.modal-wrapper--large > .modal-container[data-v-1ea9d450] {\n  max-width: 90%;\n  width: 900px;\n  max-height: min(90%, 100% - 100px);\n}\n.modal-wrapper--full > .modal-container[data-v-1ea9d450] {\n  width: 100%;\n  height: calc(100% - var(--header-height));\n  position: absolute;\n  top: 50px;\n  border-radius: 0;\n}\n@media only screen and ((max-width: 512px) or (max-height: 400px)) {\n  .modal-wrapper .modal-container[data-v-1ea9d450] {\n    max-width: initial;\n    width: 100%;\n    max-height: initial;\n    height: calc(100% - var(--header-height));\n    position: absolute;\n    top: 50px;\n    border-radius: 0;\n  }\n}\n.fade-enter-active[data-v-1ea9d450],\n.fade-leave-active[data-v-1ea9d450] {\n  transition: opacity .25s;\n}\n.fade-enter[data-v-1ea9d450],\n.fade-leave-to[data-v-1ea9d450] {\n  opacity: 0;\n}\n.fade-visibility-enter[data-v-1ea9d450],\n.fade-visibility-leave-to[data-v-1ea9d450] {\n  visibility: hidden;\n  opacity: 0;\n}\n.modal-in-enter-active[data-v-1ea9d450],\n.modal-in-leave-active[data-v-1ea9d450],\n.modal-out-enter-active[data-v-1ea9d450],\n.modal-out-leave-active[data-v-1ea9d450] {\n  transition: opacity .25s;\n}\n.modal-in-enter[data-v-1ea9d450],\n.modal-in-leave-to[data-v-1ea9d450],\n.modal-out-enter[data-v-1ea9d450],\n.modal-out-leave-to[data-v-1ea9d450] {\n  opacity: 0;\n}\n.modal-in-enter .modal-container[data-v-1ea9d450],\n.modal-in-leave-to .modal-container[data-v-1ea9d450] {\n  transform: scale(.9);\n}\n.modal-out-enter .modal-container[data-v-1ea9d450],\n.modal-out-leave-to .modal-container[data-v-1ea9d450] {\n  transform: scale(1.1);\n}\n.modal-mask .play-pause-icons .progress-ring[data-v-1ea9d450] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(-90deg);\n}\n.modal-mask .play-pause-icons .progress-ring .progress-ring__circle[data-v-1ea9d450] {\n  transition: .1s stroke-dashoffset;\n  transform-origin: 50% 50%;\n  animation: progressring-1ea9d450 linear var(--slideshow-duration) infinite;\n  stroke-linecap: round;\n  stroke-dashoffset: 94.2477796077;\n  stroke-dasharray: 94.2477796077;\n}\n.modal-mask .play-pause-icons--paused .icon-pause[data-v-1ea9d450] {\n  animation: breath-1ea9d450 2s cubic-bezier(.4, 0, .2, 1) infinite;\n}\n.modal-mask .play-pause-icons--paused .progress-ring__circle[data-v-1ea9d450] {\n  animation-play-state: paused !important;\n}\n@keyframes progressring-1ea9d450 {\n  0% {\n    stroke-dashoffset: 94.2477796077;\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n@keyframes breath-1ea9d450 {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
